
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy/debo",
      function () {
        return require("private-next-pages/privacy/debo/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy/debo"])
      });
    }
  